export enum TranslationNamespaceEnum {
  Common = "common",
  DashboardPage = "dashboardPage",
  NotFoundPage = "notFoundPage",
  LoginPage = "loginPage",
  B2BLoginPage = "B2BLoginPage",
  DataGridComponent = "dataGridComponent",
  SelectV2Component = "selectV2Component",
  AutocompleteComponent = "autocompleteComponent",

  ProTabsComponent = "proTabsComponent",
  PaginationV2Component = "paginationV2Component",
  TextAreaComponent = "textAreaComponent",
  ErrorBoundaryComponent = "errorBoundaryComponent",
  FileInputComponent = "fileInputComponent",
  DropZoneInputComponent = "dropZoneInputComponent",
  DropZoneInputComponentV2 = "dropZoneInputComponentV2",
  ExonnHubComponent = "exonnHubComponent",
  TransferListComponent = "transferListComponent",
  CommentsFormPanel = "commentsFormPanel",
  BillBalance = "billBalance",
  MarketplaceField = "marketplaceField",
  InternalServerError = "internalServerError",
  Bill = "bill",
  FormComponent = "formComponent",
  TransferPanel = "transferPanel",
  PricePanel = "pricePanel",
  Administration = "administration",

  AdminLayout = "AdminLayout",

  ManageAttributeValues = "manageAttributeValues",
  AssignAttributesToVariant = "assignAttributesToVariant",

  DateRangeStatusCell = "dateRangeStatusCell",

  SelectProductTypeModal = "selectProductTypeModal",
  SelectPriceListsModal = "selectPriceListsModal",
  AssignComponentsToSetModal = "assignComponentsToSetModal",
  DeleteRecordConfirmationModal = "deleteRecordConfirmationModal",

  EditAttributeValueModal = "editAttributeValueModal",
  CreateAttributeValueModal = "createAttributeValueModal",
  DeleteAttributeValueModal = "deleteAttributeValueModal",
  FormContactsPanel = "formContactsPanel",

  SetComponentList = "setComponentList",

  ProductsImport = "productsImport",
  AccountingExport = "accountingExport",
  DiscountGiftItemTable = "discountGiftItemTable",

  VoucherAndGeneration = "vouchers-and-generation",

  EditWarehousePlacesTab = "EditWarehousePlacesTab",

  B2BGateEmptyScreen = "B2BGateEmptyScreen",
  UnexpectedError = "unexpectedError",
  UpdateRequiredModal = "updateRequiredModal",
}
